module.exports = __webpack_public_path__ + "img/icon-community.22c185f9.svg";